import React from 'react'
import PropTypes from 'prop-types'

import { SiteContext } from 'context/site-context'

import {
  getAddress,
  getQS,
  hasServices,
  renderServices,
} from 'helpers'

import './index.scss'

const Card = props => {
  const [ site ] = React.useContext(SiteContext)

  const {
    result,
  } = props

  const getLogo = (images = [], name) => {
    if(!images) return null 

    if(images.filter(image => image.primary).length > 0){
      return <div className="logo-container"><img src={images.filter(image => image.primary)[0].originalUrl} alt={name} /></div>
    } else if(images.length > 0){
      return <div className="logo-container"><img src={images[0].originalUrl} alt={name} /></div>
    } 
    return null
  }

  const getProfileUrl = () => {
    const qs = getQS().trim().length > 0 ? `?${getQS()}` : ''
    return `${window.location.origin}/${site.path ? `${site.path}/` : ''}profile/${result.importedListingId}`
  }

  // const handleClick = (e, url) => {
  //   e.preventDefault()
  //   e.stopPropagation()

  //   // // Fire tracking URL.
  //   // try {
  //   //   let img = new Image()
  //   //   img.onload = window.location.href = url
  //   //   img.src = `${props.result.impression}&_=${new Date().getTime()}`
  //   // } catch(e){
  //   //   window.location.href = url 
  //   // }
  // }

  return <div className="card" key={result.id}>
    <a href={getProfileUrl()}>
      <div className="details-container">
        <h4 className="business-name">{result.listingName}</h4>
        <div className="address">{getAddress(result)} {result.postal_code || ''}</div>
        {hasServices(result) && <div className="services">{renderServices(result.services)}</div>}
      </div>
      {getLogo(result.images, result.name)}
    </a>
  </div>
}

Card.propTypes = {
  result: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
}

export default Card
